/*============================================================================
  APP-COLLECTION.js - Collection-specific functionality
  Only loads on collection pages and where collections are displayed
  Contains: Filtering, sorting, secondary images, quick shop
=============================================================================*/

/*============================================================================
  Collection
=============================================================================*/
var collection = {
  init: function(){
    

    if( Shopify.device.hasTouch.matches) {
      $('.quick_shop').remove();
      $('.quick_shop--list').removeAttr('data-fancybox data-src data-gallery');
    }

    if (Shopify.media_queries.xlarge.matches && $.fancybox) {
      var quickShopBaseClass = 'quick-shop__lightbox';
      if (typeof product !== 'undefined' && product.id) {
        quickShopBaseClass += ' product-' + product.id;
      }

      $('.quick_shop, .quick_shop--list').fancybox({
        baseClass: quickShopBaseClass,
        hash: false,
        infobar : false,
        toolbar: false,
        loop: false,
        smallBtn : true,
        video: { autoStart: false },
        touch: false,
        mobile: {
          preventCaptionOverlap: false,
          toolbar: true,
          buttons: [ "close" ]
        },
        afterShow: function(e) {
          var $fancyboxImageElement = $(this.opts.$orig);
          var $gallery = $('.' + $fancyboxImageElement.data('gallery'));
          var selector = $('.fancybox-is-open').find('.selector-wrapper select');
          var $productForm = $('.fancybox-is-open .js-product_section').find('.product_form');

          

          selector.trigger('change');

          var $gallery = $('.' + $fancyboxImageElement.data('gallery'));

          var galleryObject = {
            element: $gallery,
            thumbnailsEnabled: $gallery.parents('.product_section').data('thumbnails-enabled'),
            thumbnailsSliderEnabled: $gallery.parents('.product_section').data('thumbnails-slider-enabled'),
            thumbnailsPosition: $gallery.parents('.product_section').data('thumbnails-position'),
            thumbnailsArrows: $gallery.parents('.product_section').data('gallery-arrows-enabled'),
            slideshowAnimation: $gallery.parents('.product_section').data('slideshow-animation'),
            slideShowSpeed: $gallery.parents('.product_section').data('slideshow-speed'),
            activateZoom: $gallery.parents('.product_section').data('activate-zoom'),
            productMediaSupported: $gallery.parents('.product_section').data('product-media-supported'),
            videos: $gallery.find('[data-html5-video] video, [data-youtube-video]').get(),
            hasVideoMedia: $gallery.find('[data-html5-video], [data-youtube-video]').length > 0,
            loopingEnabled: $gallery.data('video-looping-enabled'),
            sectionID: null
          }

          if (typeof product !== 'undefined' && product.enableSlider) {
            product.enableSlider(galleryObject);
          }

          if (galleryObject.productMediaSupported) {
            if (typeof product !== 'undefined') {
              product.launchProductMedia(galleryObject);
            }
          }

          if (galleryObject.activateZoom && typeof product !== 'undefined' && product.initZoom) {
            product.initZoom(galleryObject.element);
          }
        },
        afterClose: function() {
          var $fancyboxImageElement = $(this.opts.$orig);
          var $gallery = $('.' + $fancyboxImageElement.data('gallery'));

          var $videosInGallery = $gallery.find('.product-gallery__image[data-media-type="video"], .product-gallery__image[data-media-type="external_video"]');
          $videosInGallery.each(function(index, video) {
            var $iframeVideo = $(video).find('iframe');
            var iframeID = $iframeVideo.attr('id');
            var $html5Video = $(video).find('[data-html5-video]');
            var videoID = $html5Video.find('video').data('plyr-video-id');

            if (($html5Video.length || $iframeVideo.length) && Array.isArray(globalPlayersArray) && globalPlayersArray.length) {
              $.each(globalPlayersArray, function(index, player) {
                if (videoID) {
                  if (player.id == videoID && player.playing) {
                    player.pause();
                  }
                } else if (iframeID) {
                  if (player.media.id == iframeID && player.playing) {
                    player.pause();
                  }
                }
              })
            }
          });
        }
      });
    }

    $('#sort-by').val($('#sort-by').data('default-sort'));

    $('body')
      .on('change', '#tag_filter, #sort-by', function() {
        var sortValue = $('#sort-by').val();
        var filterValue = $('#tag_filter').val();

        Shopify.queryParams = Shopify.queryParams || {};
        Shopify.queryParams.sort_by = sortValue;
        var sortUrl = $.param(Shopify.queryParams);

        if (sortValue && filterValue){
          window.location = filterValue + '?sort_by=' + sortValue;
        } else if (sortValue && !filterValue) {
          window.location = '?' + sortUrl;
        } else if (!sortValue && filterValue){
          window.location = filterValue;
        }
      });

    
  },

  showSecondaryImage: function(){
    if (!Shopify.device.hasTouch.matches && Shopify.media_queries.larger.matches) {
      var secondaryMediaVideos;
      secondaryMediaVideos = $('.thumbnail').find('[data-html5-video] video, [data-youtube-video]').get();
      var ensureSecondaryMediaPlyr = function() {
        var plyrLoaded = $('.shopify-section--recommended-products').find('.products').data('plyr-loaded');

        if (plyrLoaded || !secondaryMediaVideos.length || typeof utilities === 'undefined') {
          return;
        }

        utilities.loadPlyr().then(function(Plyr) {
          utilities.launchVideoPlayer(Plyr, null, secondaryMediaVideos, true);
        }).catch(function(error) {
          console.error('Failed to load Plyr for collection secondary media', error);
        });
      };

      $('.has-secondary-media-swap')
        .off('.secondaryMediaSwap')
        .on('mouseenter.secondaryMediaSwap', function() {
        ensureSecondaryMediaPlyr();
        $(this).find('.image-element__wrap img').toggleClass('secondary-media-hidden');
        $(this).find('[data-html5-video]').toggleClass('secondary-media-hidden');
        $(this).find('.external-video__container').toggleClass('secondary-media-hidden');
        if (typeof product !== 'undefined' && product.enableVideoOnHover) {
          product.enableVideoOnHover($(this));
        }
      })

      .on('mouseleave.secondaryMediaSwap', function() {
        $(this).find('.image-element__wrap img').toggleClass('secondary-media-hidden');
        $(this).find('[data-html5-video]').toggleClass('secondary-media-hidden');
        $(this).find('.external-video__container').toggleClass('secondary-media-hidden');
        if (typeof product !== 'undefined' && product.disableVideoOnHover) {
          product.disableVideoOnHover($(this));
        }
      });
    }
  },

  unload: function($target){
    $target.find('.has-secondary-media-swap').off('.secondaryMediaSwap');
    $('body').off('change', '#tag_filter, #sort-by');
    $target.find('.quick_shop, .quick_shop--list').off('click.fb');
  }
}

$(function() {
  collection.init();
});
